// ----------------------------------------------------------------------------
// Component: Helper Cards
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts

// Styles
import './_helper-cards.scss';

// -------------------------------------
// Variables
// -------------------------------------
const LIVECHAT_TRIGGER = '#js--livechat_trigger';

document.addEventListener('DOMContentLoaded', () => {
    const livechatTriggers = document.querySelectorAll(LIVECHAT_TRIGGER);

	
    livechatTriggers.forEach((element) => {
        element.addEventListener('click', (event) => {
            Reamaze.popup();
        });
    });
});